import { MOBILE_APP_AUTH_STATE } from "../mobileAppAuthConstants";

export const MOBILE_APP_AUTH_PIN_STATE_INFO = {
    [MOBILE_APP_AUTH_STATE.ENTER_PIN]: {
        title: 'lite_version.sign_up.enter_your_pin',
        description: '',
    },
    [MOBILE_APP_AUTH_STATE.PIN1]: {
        title: 'lite_version.sign_up.set_pin',
        description: 'lite_version.sign_up.enter_code',
    },
    [MOBILE_APP_AUTH_STATE.PIN2]: {
        title: 'lite_version.sign_up.confirm_pin',
        description: '',
    },
};
